import React, { Component } from "react";
import { Upload, Modal, Popconfirm, Alert, Checkbox, Tooltip } from "antd";
import { ModalItem } from "../../../../Components/Items"; // Ajusta la ruta si es necesario
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

class ModalCargarImagen extends Component {
  state = {
    listaArchivos: [],
    vistaPreviaVisible: false,
    imagenVistaPrevia: "",
    tituloVistaPrevia: "",
    guardarEnInsumo : false,

  };
  

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      const archivosEntrantes = this.props.archivosIniciales || [];

      const archivosFormateados = archivosEntrantes.map((archivo, index) => {
        let urlFinal = archivo.url;

        if (!urlFinal) {
          if (archivo.base64) {
            urlFinal = `data:image/${archivo.extension};base64,${archivo.base64}`;
          } else {
            urlFinal = archivo.path;
          }
        }

        return {
          uid: archivo.uid || String(index),
          name: archivo.name || "imagen.jpg",
          status: "done",
          url: urlFinal,
          ...archivo,
        };
      });

      this.setState({
        listaArchivos: archivosFormateados,
      });
    }
  }

  obtenerBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  manejarVistaPrevia = async (archivo) => {
    if (!archivo.url && !archivo.preview) {
      archivo.preview = await this.obtenerBase64(archivo.originFileObj);
    }
    this.setState({
      imagenVistaPrevia: archivo.url || archivo.preview,
      vistaPreviaVisible: true,
      tituloVistaPrevia:
        archivo.name || archivo.url.substring(archivo.url.lastIndexOf("/") + 1),
    });
  };

  cancelarVistaPrevia = () => {
    this.setState({ vistaPreviaVisible: false });
  };

  manejarCambio = ({ fileList }) => {
    this.setState({ listaArchivos: fileList });
  };

  peticionPersonalizada = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  cambiarCheckbox = (e) => {
    this.setState({ guardarEnInsumo: e.target.checked})
  }

  cerrarModal = () => {
    this.props.alCerrar();
  };

  guardarCambios = () => {
    this.props.alGuardar(this.state.listaArchivos, this.state.guardarEnInsumo);
  };

  render() {
    const { visible , cantidadExistente, esInsumoCambio} = this.props;
    const {
      listaArchivos,
      vistaPreviaVisible,
      imagenVistaPrevia,
      tituloVistaPrevia,
      guardarEnInsumo,
    } = this.state;

    const limiteAlcanzado = cantidadExistente >= 3;

    const botonSubir = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Subir</div>
      </div>
    );

    return (
      <>
        <ModalItem
          title="Cargar Imagen del Insumo"
          visible={visible}
          onCancel={this.cerrarModal}
          onOk={this.guardarCambios}
          width={600}
          spinning={false}
          footer
        >
          <div
           style={{ justifyContent: "center", padding: 20 }}
          >
            <Alert
              message={
                guardarEnInsumo
                  ? "La imagen aparecerá en la cotización y se guardará en el insumo."
                  : "La imagen cargada solo aparecerá en esta cotización."
              }
              type={guardarEnInsumo ? "warning" : "info"}
              showIcon
              style={{ marginBottom: 10 }}
            />
            <Alert
              message="Recomendación de imagen"
              description="Para mejor calidad en el PDF, sube una imagen de 600×600 px, preferentemente en formato PNG (fondo transparente) o JPG, con proporción cuadrada (1:1)."
              type="info"
              showIcon
              style={{ marginBottom: 15 }}
            />
            <Upload
              listType="picture-card"
              fileList={listaArchivos}
              onPreview={this.manejarVistaPrevia}
              onChange={this.manejarCambio}
              customRequest={this.peticionPersonalizada}
              maxCount={1}
              accept="image/png,image/jpeg"
              showUploadList={{
                showRemoveIcon: true,
                showPreviewIcon: true,
                removeIcon: (archivo) => (
                  <Popconfirm
                    title="¿Seguro que quieres eliminar el archivo?"
                    onConfirm={() => {
                      return true;
                    }}
                    okText="Sí"
                    cancelText="No"
                  >
                    <DeleteOutlined style={{ color: "white" }} />
                  </Popconfirm>
                ),
              }}
            >
              {listaArchivos.length >= 1 ? null : botonSubir}
            </Upload>
            {!esInsumoCambio && (
              <div style={{ marginTop: 15 }}>
                <Tooltip title={limiteAlcanzado ? "El insumo ya tiene el máximo de 3 imágenes guardadas en el catálogo." : ""}>
                  <Checkbox 
                    disabled={limiteAlcanzado} 
                    checked={!limiteAlcanzado && guardarEnInsumo} 
                    onChange={this.cambiarCheckbox}
                  >
                    Guardar esta imagen en el insumo.
                  </Checkbox>
                </Tooltip>
                {limiteAlcanzado && (
                  <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                    * Este insumo ya tiene 3 imágenes (límite máximo alcanzado).
                  </div>
                )}
              </div>
            )}
          </div>
        </ModalItem>

        <Modal
          visible={vistaPreviaVisible}
          title={tituloVistaPrevia}
          footer={null}
          onCancel={this.cancelarVistaPrevia}
        >
          <img
            alt="vista previa"
            style={{ width: "100%" }}
            src={imagenVistaPrevia}
          />
        </Modal>
      </>
    );
  }
}

export default ModalCargarImagen;
